export class StaleLocalCopyException extends Error {
    constructor(localCopy: any, failedCheckNames: string[], databaseCopy?: any) {
        super(StaleLocalCopyException.createMessage(localCopy, databaseCopy, failedCheckNames));
    }

    private static createMessage(localCopy: any, databaseCopy: any, failedCheckNames: string[]): string {
        const failedCheckNamesString = failedCheckNames.join(", ");
        let message = `Local copy of the record is stale. Failed checks: ${failedCheckNamesString}. Local copy: ${JSON.stringify(localCopy)}.`;
        if (databaseCopy) {
            message += ` Existing record: ${JSON.stringify(databaseCopy)}.`;
        }
        return message;
    }
}